module.exports = __webpack_public_path__ + "static/brown-309bf3edddadecdc26270498a5c82b71.svg";